// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"ef243d80","239":"9cd3fdec","455":"b6221f8a","907":"0b51e0e3","977":"10d80177"}[chunkId] + ".chunk.js";
};